export function round(value: number, precision: number): number {
  return Math.round(value * 10 ** precision) / 10 ** precision;
}

export function calculatePercentageValue(value = 0, total = 0): number {
  if (!total || !value) {
    return 0;
  }
  return Number(((value / total) * 100).toFixed(0));
}
